// IncidentWizard.tsx
import React, { useState } from "react";
import Page1 from "../../pages/IncidentReport/incidentReportForm.tsx";
import Page2 from "../../pages/IncidentReport/incidentReportForm_2.tsx";
import { Incident } from "../../Interfaces/types.ts";
import { baseurl, baseurly } from "../../utils/apis.ts";
import { X_API_KEY } from "../../utils/apis.ts";
import axios from "axios";

const initial: Incident = {
 equipment: "",
    equipment_id: "",
    model: "",
    work_shop: "",
    cause: "",
    operator: "",
    description: "",
    down_time: "",
    repair_fee: "",
    production_loss: "",
    remarks: "",
    date_and_time: "",
    machine_function:"",
  
    // page 2
    problem: "",
    why1: "",
    why2: "",
    why3: "",
    why4: "",
    why5: "",
    action: "",
    party_responsible: "",
    start_date: "",
    end_date: "",
};

const IncidentWizard: React.FC = () => {
  const [step, setStep] = useState<1 | 2>(1);
  const [form, setForm] = useState<Incident>(initial);

  const update = (fields: Partial<Incident>) => {
    // console.log(fields);
    
    // setForm(f => ({ ...f, ...fields }));
    setForm({...form, ...fields});
  };

  const handleSubmit = async () => {
console.log(form);


    try {
      // const res = await fetch(`${baseurly}/issues`, {
      //   method: "POST",
      //   headers: { "Content-Type": "application/json",
      //               "X-API-KEY": X_API_KEY,
      //    },
      //   body: JSON.stringify(form),
      // });
    const res = await axios.post(baseurly+"/issues", form, {
      headers: {
        "X-API-KEY": X_API_KEY,
        "Content-Type": "applikcation/json"
          

      }
    });
    console.log(res);
    

      // if (!res) throw new Error("Failed to submit");
      alert("Submitted successfully!");
      
    } catch (err) {
      console.error(err);
      alert("Submission failed");
    }
  };

  return (
    <>
      {step === 1 && (
        <Page1
          data={form}
          onChange={update}
          onNext={() => setStep(2)}
        />
      )}
      {step === 2 && (
        <Page2
          data={form}
          onChange={update}
          onBack={() => setStep(1)}
          onDone={handleSubmit}
        />
      )}
    </>
  );
};

export default IncidentWizard;
